import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Drag-and-drop task reordering controller.
//
// Makes a task list sortable via SortableJS. When a task is dropped in a
// new position, a PATCH request is sent to the task's move endpoint.
//
// Usage:
//   <ul data-controller="task-sortable"
//       data-task-sortable-quest-id-value="42">
//     <li data-task-sortable-target="item"
//         data-task-id="1"
//         data-move-url="/admin/quests/42/tasks/1/move">
//       <div data-task-sortable-target="handle">drag handle</div>
//       Task content
//     </li>
//   </ul>
//
export default class extends Controller {
  static targets = ["item", "handle"]
  static values = {
    questId: Number
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-task-sortable-target='handle']",
      animation: 150,
      ghostClass: "task-drag-ghost",
      chosenClass: "task-drag-chosen",
      dragClass: "task-drag-active",
      onEnd: (evt) => this.onSortEnd(evt)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onSortEnd(evt) {
    const item = evt.item
    const newPosition = evt.newIndex + 1 // positions are 1-based
    const moveUrl = item.dataset.moveUrl

    if (!moveUrl || evt.oldIndex === evt.newIndex) return

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    try {
      const response = await fetch(moveUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ position: newPosition })
      })

      if (!response.ok) {
        // Revert on failure by reloading
        window.location.reload()
      }
    } catch (error) {
      console.error("Failed to reorder task:", error)
      window.location.reload()
    }
  }
}
